.component {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 24px;
  border-bottom: 1px solid var(--pinkish-grey);
  background-color: var(--ice-blue);
}

.dateSpan {
  flex: 1;
  font-size: 14px;
  color: var(--marine);
  text-align: center;
}

.versionLabel {
  font-size: 12px;
  color: var(--brown-grey);
  margin-right: 5px;
}

.editButton {
  margin: 0 22px 0 12px;
  padding: 2px 10px;
  border: solid 1px var(--pinkish-grey);
  border-radius: 3px;
  background-color: var(--fully-white);
  font: inherit;
  font-size: 12px;
  color: var(--marine);
  cursor: pointer;
}

.editButton:hover {
  background-color: var(--light-grey);
}

.body {
  background-color: var(--light-grey);
  padding: 17px 22px;
  height: calc(100% - 64px);
  overflow-y: auto;
}

.grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 16px;
  padding-bottom: 120px;
}

.card {
  background-color: var(--fully-white);
  border-radius: 5px;
  padding: 10px 15px 15px 15px;
  min-width: 0;
  grid-column: span var(--span, 12);
}

/* small screens: spans are remembered but ignored, widgets stack full-width in order */
@media (max-width: 1020px) {
  .card {
    grid-column: 1 / -1;
  }
}

.cardHidden {
  opacity: 0.4;
}

.cardDragging {
  position: relative;
  z-index: 10;
  box-shadow: 0 1px 7px 0 #b2b2b2;
}

.cardToolbar {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: dashed 1px var(--pinkish-grey);
}

.dragHandle {
  flex: 1;
  cursor: grab;
  font-size: 12px;
  color: var(--marine);
  user-select: none;
}

.toolbarButton {
  margin-left: 8px;
  padding: 2px 8px;
  border: solid 1px var(--pinkish-grey);
  border-radius: 3px;
  background-color: var(--fully-white);
  font: inherit;
  font-size: 12px;
  color: var(--marine);
  cursor: pointer;
}

.toolbarButton:hover {
  background-color: var(--light-grey);
}

.toolbarButton:disabled {
  color: var(--bb-grey);
  cursor: default;
  background-color: var(--fully-white);
}

.spanLabel {
  margin-left: 8px;
  font-size: 12px;
  color: var(--brown-grey);
}
